import 'react-app-polyfill/ie11';
//import "core-js/stable";
import "core-js/features/string/starts-with";
import "core-js/features/string/repeat";
import "core-js/features/string/virtual/repeat";
import "core-js/features/array/find";
import "core-js/features/array/includes";
import 'core-js/features/url-search-params'
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <React.Fragment>
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>    
  </React.Fragment>,
  rootElement);
//<div style={{textAlign: "center", color: "lightgray", marginTop: "2em", fontSize: "0.6em"}}>app: V1.5.13</div>
registerServiceWorker();
